var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6289 29.2678C60.5981 28.2915 60.5981 26.7085 59.6289 25.7322C58.6596 24.7559 57.0881 24.7559 56.1188 25.7322L33.0539 48.9645L24.881 40.7322C23.9117 39.7559 22.3402 39.7559 21.371 40.7322C20.4017 41.7085 20.4017 43.2915 21.371 44.2678L31.2989 54.2678C32.2682 55.2441 33.8397 55.2441 34.809 54.2678L59.6289 29.2678Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2117 40C80.2117 62.0914 62.4321 80 40.4999 80C18.5677 80 0.788086 62.0914 0.788086 40C0.788086 17.9086 18.5677 0 40.4999 0C62.4321 0 80.2117 17.9086 80.2117 40ZM75.2477 40C75.2477 59.33 59.6906 75 40.4999 75C21.3092 75 5.75206 59.33 5.75206 40C5.75206 20.67 21.3092 5 40.4999 5C59.6906 5 75.2477 20.67 75.2477 40Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidaction);
export default __webpack_public_path__ + "static/media/Validaction.3c37ea1c8442e33607f9a2b50e2f2356.svg";
export { ForwardRef as ReactComponent };